import {
  Form,
  Input,
  InputNumber,
  Button,
  Card,
  Switch,
  Select,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../context";
import UploadBanners from "../UploadBanners/index";

const getWebseriesOptionValue = (item) => item?._id ?? item?.id;

const { TextArea } = Input;

const ReelForm = ({
  initialValues = {},
  loading = false,
  submitLabel = "Save",
  onSubmit,
}) => {
  const { getWebseriesDropdown } = useContext(Context);
  const [form] = Form.useForm();
  const [webseries, setWebseries] = useState([]);
  const [loadingSeries, setLoadingSeries] = useState(false);

  useEffect(() => {
    fetchWebseries();
    // getWebseriesDropdown is a stable App.js export — run once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      form.setFieldsValue({
        title: "",
        hindiTitle: "",
        seriesId: "",
        playbackUrl: "",
        iosPlaybackUrl: "",
        thumbnailImage: "",
        priority: null,
        status: true,
        ...initialValues,
      });
    }
  }, [form, initialValues]);

  const fetchWebseries = async () => {
    try {
      setLoadingSeries(true);

      const data = await getWebseriesDropdown();

      setWebseries(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingSeries(false);
    }
  };

  return (
    <Card>
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          title: "",
          hindiTitle: "",
          seriesId: "",
          playbackUrl: "",
          iosPlaybackUrl: "",
          thumbnailImage: "",
          priority: null,
          status: true,
          ...initialValues,
        }}
        onFinish={onSubmit}
      >
        <Form.Item
          label="Title"
          name="title"
          rules={[
            {
              required: true,
              message: "Please enter reel title",
            },
          ]}
        >
          <Input placeholder="Enter reel title" />
        </Form.Item>

        <Form.Item label="Hindi Title" name="hindiTitle">
          <Input placeholder="Enter hindi title" />
        </Form.Item>

        <Form.Item
          label="Webseries"
          name="seriesId"
          rules={[
            {
              required: true,
              message: "Please select a webseries",
            },
          ]}
        >
          <Select
            showSearch
            loading={loadingSeries}
            placeholder="Select webseries"
            optionFilterProp="label"
            options={webseries.map((item) => ({
              value: getWebseriesOptionValue(item),
              label: item.title,
            }))}
          />
        </Form.Item>

        <Form.Item label="Playback URL" name="playbackUrl">
          <TextArea
            rows={2}
            placeholder="https://content.minipix.co/reels/.../stream.mpd"
          />
        </Form.Item>

        <Form.Item label="iOS Playback URL" name="iosPlaybackUrl">
          <TextArea
            rows={2}
            placeholder="https://content.minipix.co/reels/.../stream.m3u8"
          />
        </Form.Item>

        <Form.Item name="thumbnailImage" label="Thumbnail Image">
          <UploadBanners
            name="thumbnailImage"
            type="series"
            updateForm={form}
          />
        </Form.Item>

        <Form.Item
          label="Priority"
          name="priority"
          tooltip="Optional. Lower value generally means higher placement."
        >
          <InputNumber
            min={1}
            style={{ width: "100%" }}
            placeholder="Enter priority"
          />
        </Form.Item>

        <Form.Item label="Status" name="status" valuePropName="checked">
          <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            {submitLabel}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ReelForm;
